<template>
  <div class="GlobalFormDemo">
    <GlobalForm :init-data="initData" :form-item-list="formItemList" :inline="true" :needBtnLoading="true" round @handleConfirm="handleConfirm"
      confirmBtnName="查询">
      <div style="text-align: right; margin-bottom: 20px" slot="AddSlot">
        <el-button size="small" type="success" icon="el-icon-download" :loading="exportLoading" @click="exportTable()">导出Excel</el-button>
      </div>
    </GlobalForm>
  </div>
</template>

<script>
import { formValidateMobile } from "@/utils/form-validate";
import _api from "@/utils/request";
import { http } from "../../../utils/request/newIndex";
export default {
  name: "Form",
  data() {
    return {
      // 导入弹窗
      seachParams: {
        inType: "",
        mobile: "",
        name: "",
        startTime: "",
        endTime: "",
        pageNum: 1,
        pageSize: 10,
      },
      initData: null,
      formItemList: [
        // {
        //   key: "name",
        //   type: "input",
        //   labelName: "用户名称",
        //   placeholder: "请输入用户名称",
        // },
        {
          key: "mobile",
          type: "input",
          labelName: "用户手机号",
          placeholder: "请输入用户手机号",
        },
        {
          key: "inType",
          type: "select",
          lableWidth: "100px",
          labelName: "入驻方式",
          option: [
            {
              value: "",
              label: "全部",
            },
            {
              value: "01",
              label: "自主入驻",
            },

            {
              value: "02",
              label: "店员分享",
            },
            {
              value: "03",
              label: "门店扫码",
            },
            {
              value: "04",
              label: "顾客分享",
            },
          ],
        },
        {
          key: "entryTime",
          type: "daterange",
          labelName: "入驻时间",
          placeholder: "请选择申请时间",
          valueFormat: "timestamp",
        },
        { slot: "AddSlot" },
      ],
      exportLoading: false
    };
  },
  created() {
    this.handleConfirm();
  },

  methods: {
    handleBtn() {
      this.$router.push("/OnlinreyService/addAds");
    },
    //查询
    handleConfirm(data,cd) {
      if (data) {
        if (data.entryTime === null) {
          (this.startTime = ""), (this.endTime = "");
        } else {
          (this.startTime = data.entryTime[0]),
            (this.endTime = data.entryTime[1]);
        }
      } else {
        (this.startTime = ""), (this.endTime = "");
      }
      this.seachParams = {
        inType: data && data.inType ? data.inType : "",
        mobile: data && data.mobile ? data.mobile : "",
        name: data && data.name ? data.name : "",
        startTime: data && this.startTime ? this.startTime : "",
        endTime: data && this.endTime ? this.endTime : "",
        pageNum: 1,
        pageSize: 10,
        disuseLoding: () => {
          if (typeof cd === 'function') {
            cd()
          }
        },
      };
      this.$store.commit("tagsView/SEACH_PARAMS", this.seachParams);
    },

    exportTable() {
      this.seachParams.pageNum = 1;
      this.seachParams.pageSize = 99999999;
      this.exportLoading = true
      _api.userExcel(this.seachParams).then((res) => {
        console.log(res);
        const content = res;
        const blob = new Blob([content]);
        let reader = new FileReader(); // 创建读取文件对象
        reader.addEventListener("loadend", () => {
          try {
            let data = JSON.parse(reader.result);
            if (data.code === 0) {
              this.$message.error(data.msg || "服务异常");
            }
          } catch (err) {
            const fileName = "用户列表.xlsx";
            if ("download" in document.createElement("a")) {
              // 非IE下载
              const elink = document.createElement("a");
              elink.download = fileName;
              elink.style.display = "none";
              elink.href = URL.createObjectURL(blob);
              document.body.appendChild(elink);
              elink.click();
              URL.revokeObjectURL(elink.href); // 释放URL 对象
              document.body.removeChild(elink);
            } else {
              // IE10+下载
              navigator.msSaveBlob(blob, fileName);
            }
          }
        });
        reader.readAsText(blob, "utf-8");
      }).finally(() => {
        this.exportLoading = false
      });
    },
  },
};
</script>

<style scoped lang="scss" ref="stylesheet/scss">
.GlobalFormDemo {
  .step {
    .step-title {
      display: flex;
      color: #ff687b;
      margin-bottom: 18px;
    }

    .fileName {
      /deep/.el-input {
        width: 260px;
      }
    }

    .step-content {
      margin-bottom: 20px;
    }
  }
}
</style>
